import {
  ApiPagination,
  BaseResponse,
  Filters,
  RequestPagination,
} from '@/types';

export namespace PurchaseOrders {
  export enum Pages {
    PURCHASE_ORDER = 'purchase-orders',
    PURCHASE_ORDER_DETAIL = 'purchase-order',
  }

  export type PurchaseOrder = {
    [key: string]: unknown,
    id: string | number,
    external_id: string | null,
    partner_code: string | null,
    number: string | null,
    contractor_or_brand: string | null,
    contact_person: string | null
    contact_email: string | null,
    thematics: string | null,
    organization: string | null,
    status: string | null,
    region: string | null,
    city: string| null,
    address: string | null,
    store: string | null,
    created_date: string | null,
    closed_date: string | null,
    preferred_visit_date: string | null,
    desired_execution_from: string | null,
    desired_execution_to: string | null,
    issue_description: string | null,
    partner_url: string | null,
    atol_employee: string | null,
    atol_employee_email: string | null,
    atol_employee_phone: string | null,
    is_unread: boolean | null,
  }

  export type UpdatePurchaseOrderPayload = {
    id?: string | number,
    status: string | null,
  }

  export interface Equipment {
    [key: string]: unknown,
    id?: string | number,
    purchase_order_id: string | null,
    serial_number?: string | null,
    model: number | null,
    price: string | null,
  }

  export interface File {
    [key: string]: unknown,
    id?: string | number,
    name: string | null,
    created_at: string | null,
  }

  export interface Status {
    [key: string]: unknown,
    name: string,
    value: string | null,
  }
}

export interface PurchaseOrdersFilters extends Filters {
  [key: string]: unknown,
  created_date: string | null;
  closed_date: string | null;
  statuses: string[] | null;
  contractors_or_brands: string[] | null;
}

export type PurchaseOrderRequestFilters = {
  [key: string]: unknown,
  search: string | null,
  statuses: string[] | null,
  contractors_or_brands: string[] | null,
  created_date: string | null;
  closed_date: string | null;
}

export type PurchaseOrderRequest = {
  filters: PurchaseOrdersFilters,
  filters_exist: boolean,
  pagination: RequestPagination,
}

export interface PurchaseOrderTableResponse extends BaseResponse, ApiPagination {
  data: {
    items: PurchaseOrders.PurchaseOrder[],
    filters: {
      contractors_or_brands: string[],
      statuses: string[],
    }
  }
}

export interface PurchaseOrderResponse extends BaseResponse {
  data: {
    purchase_order: PurchaseOrders.PurchaseOrder,
    statuses: PurchaseOrders.Status[],
  }
}

export interface PurchaseOrderUpdateResponse extends BaseResponse {
  data: PurchaseOrders.PurchaseOrder
}

export type EquipmentRequest = {
  filters: [],
  filters_exist: boolean,
  pagination: RequestPagination,
}

export interface EquipmentResponse extends BaseResponse, ApiPagination {
  data: {
    items: PurchaseOrders.Equipment[]
  }
}

export type FilesRequest = {
  filters: [],
  filters_exist: boolean,
  pagination: RequestPagination,
}

export interface FilesResponse extends BaseResponse, ApiPagination {
  data: {
    items: PurchaseOrders.File[]
  }
}

export interface FileResponse extends BaseResponse {
  data: PurchaseOrders.File
}
